<template>
    <div class="newsContent scrollView" @scroll="elementScroll($event)" :class="{black:data.type==6}" ref="scrollView">
        <div v-if="data.type==6">
            <!--            图集-->
            <div class="imgGroupTitle">
                {{data.title}}
            </div>
            <van-swipe class="my-swipe" :height="height" :show-indicators="false" :loop="false" duration="300">
                <van-swipe-item v-for="(item,index) in imglist">
                    <van-image :src="item.img"
                               width="100%"
                               height="100%"
                               lazy-load
                               fit="contain"
                    >
                        <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                        <template v-slot:error>加载失败</template>
                    </van-image>
                    <div class="info_2">
                        <div>
                            {{item.text}}
                        </div>
                        <div class="index">{{index+1}}/{{imglist.length}}</div>
                    </div>
                </van-swipe-item>


            </van-swipe>


            <div class="bar content-replay-controller-bar" @click="opendownload()">
                <div class="content-replay-controller-bar-inputbtn" :style="{width:'50%'}"

                >

                    <span>写评论...</span>
                </div>
                <div >
                    <van-icon size="26" :name="require('../assets/replay-replay-light.svg')" :badge="replaynumber"></van-icon>
                </div>
                <div >
                    <van-icon size="26" :name="require('../assets/replay-praise-light.png')" />
                </div>
                <div >
                    <van-icon size="26" :name="require('../assets/replay-forward-light.svg')" />
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="data.play_url">

                <video
                        style="width: 100%; display: block"
                        :src="data.play_url"
                        controls
                        x5-video-player-fullscreen='true'
                        x-webkit-airplay='true'
                        webkit-playsinline='true'
                        playsinline='true'
                        x5-playsinline
                        autoplay
                        :poster="data.thumb[0]"></video>
            </div>
            <div class="content allowSelect">


                <div class="content-title">
                    <span>{{data.title}}</span>
                    <div class="content-title-listen" @click="playvoice()" v-if="data.voice_status" :class="{roating:state.playState==='playing'}"></div>
                </div>

                <div class="info ">
                    <!--                    <div class="info-icon" v-if="api.pageParam.ad_code">{{api.pageParam.ad_code}}</div>-->
                    <div class="info-left">
                        <div class="info-from">来源：{{data.author}}</div>
                        <div class="info-publish_time">{{data.publish_time}}</div>
                    </div>
                    <div class="info-right" ref="infoRight">
                        <div class="info-row-item" v-if="data.pv_num">
                            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7456"
                                 width="200" height="200">
                                <path d="M999.722667 449.024C886.912 324.864 699.733333 193.621333 512 196.266667 324.266667 193.578667 137.088 324.906667 24.234667 449.024a94.336 94.336 0 0 0 0 125.781333C135.722667 697.642667 320.298667 827.733333 505.130667 827.733333h13.141333c185.472 0 369.962667-130.090667 481.578667-252.970666a94.293333 94.293333 0 0 0-0.128-125.738667zM315.733333 512a196.266667 196.266667 0 1 1 196.266667 196.266667A196.266667 196.266667 0 0 1 315.733333 512z"
                                      p-id="7457" fill="#818181"></path>
                                <path d="M512 512m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z"
                                      p-id="7458" fill="#818181"></path>
                            </svg>
                            <i>{{parseInt(data.pv_num)>10000?(parseInt(data.pv_num)/10000).toFixed(1)+'万':data.pv_num}}</i>
                            <span>人已阅读</span>
                        </div>
                    </div>

                </div>
                <div class="article-content font-nomal" v-html="data.content" @click="DetailClick($event)"></div>

                <ul class="live_article" v-if="data.type==11">
                    <!--                    图文直播-->
                    <li class="live_article_item" v-for="item in live_lists">
                        <img src="../assets/live_liststyle.svg" class="live_article_item_liststyle">
                        <div class="live_article_item_date">
                            {{item.publish_time | getDateDiff}}
                        </div>
                        <div class="live_article_item_user">{{item.author}}</div>
                        <div class="live_article_item_content">{{item.content}}</div>
                        <div class="live_article_item_imglist" v-if="item.imgurl && item.imgurl.length>0">
                            <img v-lazy='img' v-for="img in item.imgurl">
                        </div>
                    </li>

                    <div class="load-more"  @click="getArticleImg_live_lists()">
                        <div class="loadmore-btn">{{live_loaded?"加载完成":"点击加载更多"}}</div>
                    </div>

                </ul>


            </div>
            <div class="line"></div>

            <!--        相关新闻-->
            <div class="more_news" v-if="data.about_list && data.about_list.length>0 && data.type!=11">
                <div class="more_news_title">
                    相关新闻
                </div>
                <div class="news-list-item font-nomal" v-for="item in data.about_list" @click="openContent(item)">
                    <div class="news-list-item-row">
                        <div class="news-list-item-row-left">
                            <div class="news-list-item-title text-overflow">
                                {{item.title}}
                            </div>

                            <div class="news-list-item-date ">
                                <span class="is_stick" v-if="item.is_stick">置顶</span>
                                <span class="is_spec" v-if="item.is_spec">推荐专栏</span>
                                <span v-if="data.author">{{item.author}}</span>
                                <span>{{item.publish_time | getDateDiff}}</span>
                            </div>
                        </div>
                        <img v-lazy="item.thumb+'?x-oss-process=image/resize,m_lfit,h_200,w_360'"
                             class="news-list-item-img news-list-item-img-right">

                    </div>

                </div>
                <div class="line"></div>

            </div>

            <!-- 全部评论-->
            <div class="replay-containner">
                <div class="replay-containner-title">全部评论</div>
                <div class="replay-empty" v-if="replaylist.length === 0">没有评论快来抢沙发吧</div>
                <div class="replay-item font-nomal" v-for="item in replaylist" v-else>
                    <!--                <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">-->
                    <img class="replay-item-avatar" :src="item.head_img" @error="setdefaultImg($event)">

                    <div class="replay-item-c">
                        <div class="replay-item-name">
                            <div class="replay-item-name-user">{{item.user_name}}</div>
                            <!--                            <div class="replay-item-name-praise">-->
                            <!--                                <img src="../../../image/replay-praise.png">-->
                            <!--                                <span>赞</span>-->
                            <!--                            </div>-->
                        </div>

                        <div class="replay-item-content" v-html="item.content"></div>
                        <div class="replay-item-info">
                            <span>{{item.create_time}}&nbsp;</span>
                            <i></i>
                        </div>
                    </div>
                </div>


            </div>


            <a @click="opendownload()" class="bottom_btn_">打开APP查看更多精彩评论</a>
        </div>
        <van-overlay v-if="showad" :show="showad"  @click="closead()">
            <div class="wrapper" v-if="data.ad_info">
                <div class="ad_containner"  @click.stop>
                    <img :src="data.ad_info.img_url" @click="closead()">
                    <div class="ad_close" @click="closead()">
                        <van-icon name="cross" />
                    </div>
                </div>

            </div>
        </van-overlay>
    </div>
</template>
<style scoped>

    @import '../assets/css/listcomponentscss.css';
    .newsContent{ display: block !important;}
    .content{ padding:15px; padding-top: 0}
    .back img{ height: 18px; display: block}
    .line{ width: 100%; height: 6px; background-color: #f0f0f0}

    .v-header{ position: relative;}
    .v-header-back{ left: 15px; z-index: 100; position: absolute; }
    .v-header-back img{ height: 18px; display: block}
    .content-title{ font-size: 24px; color: #323232; padding: 15px 0; letter-spacing: 1px; line-height: 1.4; font-weight: bold}
    .content-title span{ vertical-align: middle}
    .content-text{ font-size: 14px; color: #8e8e8e}


    .article-content>div,.article-content>p{ max-width: 100% !important; }
    .article-content img{ max-width: 100%; object-fit: contain}
    .article-content{ font-size: 20px; line-height: 1.8}

    .van-info{ font-size: 9px !important;}
    .article-content span,.article-content strong,.article-content a{ display: inline !important;}
    .article-content a{text-decoration: underline; display: inline; color: #0000ee}
    .article-content video{ max-width: 100%; display: block; margin: 10px auto}
    .info{ padding:10px;  font-size: 12px; color: #818181;background-color: #f8fafb;line-height: 20px; margin-bottom:10px; display: flex;
        align-items: center; justify-content: space-between}
    .info-left{ flex: 1; margin-right: 10px}
    .info-right{  position: relative;display: flex;  align-items: center}
    .info-right>div{ margin-right: 0}
    .info-right>svg{ width: 30px; height: 30px;}
    .info-right>svg path{ fill: #c9cacb}
    /*.info div{ margin-right: 8px}*/
    .info-icon{ border:0.5px solid red; color: red; line-height: 20px; padding: 0 8px; border-radius: 20px;}
    .wrapper{ display: flex !important;justify-content: center; align-items: center;height: 100%}
    .ad_close{ width: 30px; height: 30px; background-color: #7c7c7c; border-radius: 50%; border:1px solid #fff; display: flex;justify-content: center; align-items: center;
        color: #fff;position: absolute;; right: -15px;top:-15px
    }
    .ad_containner{ width: 60%; position: relative }
    .wrapper img{ max-width: 100%; object-fit: contain}
    .content-title-listen{ background-color: #ff6c6c; display: inline-block; vertical-align: middle; margin-left: 4px; width: 30px; height: 30px;
        border-radius: 50%; font-size: 0; line-height: 30px; text-align: center;background-image: url(../assets/listen.svg);background-repeat: no-repeat;background-position: center center;
        background-size: 20px auto}
    .content-title-listen img{ height: 20px; display:inline}

    .show .scrollView,.show .content-replay-controller,.show .video-placeholder,.show .wrapper{ display: block}

    .news-list-item-scrolltext.fixed{ bottom: 50px !important;}
    .info-row-item{ display: flex; align-items: center;  padding: 0 6px; font-size: 12px; height: 20px; line-height: 20px; border-radius: 1px;

    }
    .info-row-item i{ font-style: normal; font-size: 12px}
    .info-row-item svg{ width: 15px; height: 18px; margin-right: 3px; }
    .info-row-item svg path{ fill: #818181}
    .info-row-item .news-list-replay-icon{width: 15px; height: 15px;}
    .info-from{ font-size: 14px; color: #323232}
    .info-publish_time{ font-size: 10px; line-height: 20px}
    .xinagq{ font-size: 14px; flex: 1; height: 32px; display: flex; align-items: center; color: #1989fa; text-align: center;}

    .article_{ width: 100%;  padding:20px 10px; font-size: 12px; line-height: 24px; border: 1px solid red; color: #000; position: relative;
        margin-top: 30px; background-color: #f0f0f0;
    }
    .article__title{ font-size: 18px; font-weight: bold; text-align: justify-all; background-color: #fff; position: absolute; left: 50%; top: 0;
        transform: translateY(-5px) translateX(-50%);line-height: 10px}
    .article_ .article__row{ display: flex; align-items: center; justify-content: space-between}
    .more_news_title{ font-size: 20px; line-height: 30px; padding-left: 10px; border-left: 5px solid red; margin-top: 15px}
    .xinagq img{ height: 100%}

    .header-end{ color: #1989fa}
    .news-list-item-scrolltext.fixed{ border-bottom: none}
    .xinagq .van-notice-bar{ background-color: transparent !important; color: #1989fa !important; padding-left: 0 !important;}
    .van-overlay{ background-color: rgba(0,0,0,0.3) !important;}
    .roating{ animation:roate 5s infinite linear}
    @keyframes roate {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    .bottom_btn_ {
        display: block;
        width: 80%;
        margin: .6rem auto;
        border-radius: 20px;
        text-align: center;
        color: #fff;
        background: #ee1a1a;

        font-size: 16px;
        line-height: 40px;
        height: 40px;
    }
    .black{ background-color: #2c2c2c}







    .img{ display: block; width: 100%; height: 100%; object-fit: cover}
    .info_2{ position: absolute; padding: 13px; box-sizing: border-box; width: 100%; left: 0; bottom:0; font-size: 14px; color: #fff;
        background-image: -webkit-linear-gradient( 90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%);
    }

    .bar{ height: 50px; background-color: #333333}
    .index{ position: absolute; top: -50px; right: 15px; background-color: rgba(0,0,0,0.5); color: #fff; font-size: 14px; padding: 0 6px;
        height: 22px; line-height: 22px; border-radius: 22px}
    /*.info>div{ transform: translateY(100%); transition: 0.3s}*/
    .bar .content-replay-controller-bar-inputbtn{ background-color: #6E6E6E; color: #999999; border:none}
    .imgGroupTitle{ width:100%; padding: 10px; color: #fff; position: absolute; left: 0; top:50px; z-index: 2; font-size: 16px}
    .live_article_item_content{ font-size: 18px; line-height:1.6; text-align: justify }
    .live_article_item_imglist img{ display: block; margin: 10px 0; max-width: 100%}
    .live_article_item_imglist{ overflow: hidden}

    .load-more{  display: flex; justify-content: center; align-items: center}
    .loadmore-btn{ background-color: red; color: #fff; border-radius: 2px; font-size: 12px; padding: 3px 10px;}

</style>
<script>

    import { ImagePreview } from 'vant';
    import layVideo from '@/components/Video.vue'
    import config from '../config'
    import utils from '../utils'
    import { Toast } from 'vant';
    import request from "../utils/request";
    export default {
        data(){
            return{
                data:{
                    about_list:[],

                },
                replaylist:[],
                live_lists:[],
                page:1,
                replaypage:1,
                bottomDistance:100,
                showad:false,
                height:window.innerHeight - 100,
                state:{
                    playState:'',
                    duration:''
                },//音频播放器状态
                imglivepage:1,
                pageid:this.$route.params.id,
                live_loaded:false,
                praised:false
            }
        },
        name: 'newsContent',
        created() {

            this.getData();
            this.getreplay();

            this.createAudio();
            this.height = window.innerHeight -100;
        },
        filters: {
            time: function time(t) {
                if (!t) return "";
                var i = new Date(1e3 * t),
                    e = i.getFullYear(),
                    s = i.getMonth() + 1,
                    a = i.getDay();
                i.getHours(), i.getMinutes(), i.getSeconds();
                return e + "-" + s + "-" + a;
            },
            getDateDiff: function getDateDiff(t) {
                if (t) {
                    var i = new Date().getTime() - Date.parse(t.replace(/-/gi, "/"));
                    if (i < 0) return;
                    var e = i / 2592e6,
                        s = i / 6048e5,
                        a = i / 864e5,
                        n = i / 36e5,
                        o = i / 6e4;
                    return e >= 1 ? parseInt(e) + "月前" : s >= 1 ? parseInt(s) + "周前" : a >= 1 ? parseInt(a) + "天前" : n >= 1 ? parseInt(n) + "小时前" : o >= 1 ? parseInt(o) + "分钟前" : "刚刚";
                }
            }
        },
        components: {
            [ImagePreview.Component.name]: ImagePreview.Component,
            layVideo
        },
        methods:{
            //获取图文直播
            getArticleImg_live_lists(){
                let id = this.pageid ?this.pageid:this.$route.params.id;
                request.getArticleImg_live_lists(id,this.imglivepage,(res=>{
                    if(res && res.code ==200){
                        var replaylist = this.live_lists.concat(res.data);
                        this.live_lists = utils.arrayDelRepeat(replaylist, 'live_id');
                        if (res.data.length < 5) {
                            this.live_loaded = true;
                        } else {
                            this.live_loaded = false;
                        }
                    }
                }))
                this.imglivepage++;
            },
            //音频播放器
            createAudio(){
                let state = this.state
                var audio = document.createElement('audio');
                audio.onended = function (event) {
                    state.playState = 'end';

                }; //播放


                audio.onplay = function (event) {
                    state.playState = 'playing';
                    console.log('播放');


                }; // //加载出错


                audio.onerror = function (event) {
                    state.playState = 'error';
                    console.log('加载出错');
                }; //缺少数据缓存等待中


                audio.onwaiting = function (event) {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;
                    state.playState = 'waiting';
                }; //视频播放中


                audio.onplaying = function (event) {
                    state.playState = 'playing';


                }; //可以播放


                audio.oncanplay = function (event) {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;
                }; //暂停


                audio.onpause = function (event) {
                    state.playState = 'pause';
                    console.log('暂停');
                }; //当媒介资源元素突然为空时（网络错误、加载错误等）运行脚本


                audio.onemptied = function () {
                    state.playState = 'error';
                };

                audio.ondurationchange = function () {
                    state.duration = audio.duration;
                    state.currentTime = audio.currentTime;

                };
                this.audio = audio;
            },
            //关闭广告
            closead: function closead() {
                this.showad = false;

                if (this.isvideo) {
                    //openplayer(api.safeArea.top, this.videourl, 200, this.data.thumb[0]);
                }
            },
            getData(){
                let id = this.pageid ?this.pageid:this.$route.params.id;
                request.getNewsContent(id,(res)=>{
                    var _this10 = this;
                    res.data.content = res.data.content.replace(/<video [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<video[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var url = '';

                        while (reg.exec(match)) {
                            url = RegExp.$1;
                        }

                        if (url) {
                            return '<video controls webkit-playsinline="true" x5-playsinline="true" playsinline="true"  x-webkit-airplay="true" src="' + url + '" poster="' + url + '?x-oss-process=video/snapshot,t_2000,f_jpg,m_fast" >';
                        }

                        return '';
                    });

                    var imgnumber = -1;
                    var content_imgs = [];
                    res.data.content = res.data.content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<img[^>]*src[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var src = '';

                        while (reg.exec(match)) {
                            src = RegExp.$1;
                        }

                        if (src) {
                            content_imgs.push(src);
                            imgnumber++;

                            if (src.indexOf('img2.yitoutiao.net') !== -1) {
                                return "<img src='" + src + "?x-oss-process=image/resize,m_lfit,w_700' data-index='" + imgnumber + "'>";
                            } else {
                                return "<img src='" + src + "' data-index='" + imgnumber + "'>";
                            }
                        } else {
                            return '';
                        }
                    });
                    res.data.content = res.data.content.replace(/<a [^>]*href=['"]([^'"]+)[^>]*>/gi, function (match, f) {
                        var reg = /<a[^>]*href[=\'\"\s]+([^\"\']*)[\"\']?[^>]*>/gi;
                        var url = '';

                        while (reg.exec(match)) {
                            url = RegExp.$1;
                        }

                        if (url) {
                            return "<a href='" + url + "' target=\"_bank\">";
                        }
                    });

                    var font18 = /font\-size\:\s18px/gim;
                    res.data.content = res.data.content.replace(font18, '');
                    var liheight = /line\-height\:\s2em/gim;
                    res.data.content = res.data.content.replace(liheight, '');
                    _this10.content_imgs = content_imgs;

                    if (res.data.ad_info && res.data.ad_info.img_url) {
                        _this10.showad = true;
                    }

                    if(res && res.code==200){
                        this.data = res.data
                    }


                    if(res.data.type==6){
                        var imglist = [];
                        for (var i = 0; i < res.data.thumb.length; i++) {
                            imglist.push({
                                img: res.data.thumb[i],
                                text: res.data.imgtxt[i] ? res.data.imgtxt[i] : res.data.title
                            });
                        }
                        _this10.imglist = imglist;
                    }else if(res.data.type==11){
                        this.getArticleImg_live_lists()
                    }
                    //显示广告
                    if (res.data.ad_info && res.data.ad_info.img_url) {
                        this.showad = true;
                    }
                    this.praised = res.data.is_praise;

                    //
                    let shareurl = 'http://img2.yitoutiao.net/t/index.html#/newsContent&id='+ this.pageid;
                    request.getWeixinShanre(location.href,(s_res)=>{
                        let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                        let shareconfig = {appId,timestamp,nonceStr,signature};
                        if(utils.is_weixin()){
                            if(res.data){
                                let sharedata = {
                                    title:res.data.title?res.data.title:"看度时政",
                                    desc:res.data.desc?res.data.desc:"看度时政",
                                    link:location.href,
                                    imgUrl:thumb
                                };
                                utils.setWeiXinShareTest(sharedata,shareconfig,false)
                            }

                        }
                    });

                    try{
                        this.$refs.scrollView.scrollTop =0
                    }catch (e) {
                        console.log(e)
                    }

                })
            },
            getreplay: function getreplay() {
                var page = this.replaypage;
                let id = this.pageid ?this.pageid:this.$route.params.id;
                request.getNewsContentReplay({id:id, page:page},  (res, err)=> {
                    if (err) {
                        return;
                    }

                    if (res.code == 200) {
                        this.replaypage++;

                        var replaylist = this.replaylist.concat(res.data);
                        console.log(replaylist)
                        this.replaylist = utils.arrayDelRepeat(replaylist, 'com_id');
                    }
                });
            },

            playvoice(){
                if(!this.state.playState){
                    let voice = '';
                    if (this.data['voice_pth_girl']) {
                        voice = this.data['voice_pth_girl'];
                    } else if (this.data['voice_pth_man']) {
                        voice = this.data['voice_pth_man'];
                    } else if (this.data['voice_sch_girl']) {
                        voice = this.data['voice_sch_girl'];
                    } else if (this.data['voice_yy']) {
                        voice = this.data['voice_yy'];
                    }

                    this.audio.src=voice;
                    this.audio.play()
                }else if(this.state.playState==='playing'){
                    this.audio.pause()
                }else{
                    this.audio.play()
                }
            },
            setdefaultImg(e){
                var el = e.currentTarget;
                el.src = require('../assets/default_header.svg');
            },
            DetailClick(e){

                if (e.target.nodeName === 'IMG') {
                    var index = e.target.getAttribute('data-index');
                    ImagePreview({
                        images: this.content_imgs,
                        startPosition: parseInt(index),
                        onClose: function onClose() {// do something
                        }
                    });
                }
            },
            scrollbottom: function scrollbottom() {

                if(this.data.type==11){
                    this.getArticleImg_live_lists()
                }else{
                    this.getreplay()
                }


            },
            elementScroll(e){

                //滚动到了底部
                if(this.scrollbottom){
                    var topheight = e.target.offsetHeight + e.target.scrollTop;
                    if((topheight+ this.bottomDistance) >= e.target.scrollHeight  && this.lastscroll<e.target.scrollTop){
                        if(this.scrollTopTimeOut){
                            clearTimeout(this.scrollTopTimeOut);
                            this.scrollTopTimeOut = false;
                        }
                        if(this.allow_run_scrollbottom){
                            this.scrollbottom();
                            this.allow_run_scrollbottom = false;
                        }
                        this.scrollTopTimeOut = setTimeout(()=>{
                            this.allow_run_scrollbottom = true;
                        },50);
                    }
                    this.lastscroll = e.target.scrollTop
                }

            },
            opendownload(){
                let id = this.pageid ?this.pageid:this.$route.params.id;
                let url = 'shenniao://app?code={"module":"zixun","page":"art_info","id":'+id+'}';
                setTimeout(()=>{
                    location.href = 'http://img2.yitoutiao.net/app/download.html';
                },500)
                location.href = url;
            },
            openContent(item){
                this.pageid = item.art_id;
                //location.href = 'http://img2.yitoutiao.net/t/index.html#NewsContent&id='+item.art_id;
                //location.href = 'http://localhost:8080/#/NewsContent&id='+item.art_id;
                this.replaylist = [];

                setTimeout(()=>{
                    this.getData();
                    this.getreplay();


                    setTimeout(()=>{
                        document.querySelector('.scrollView').scrollTop = 0;
                        location.href = 'http://img2.yitoutiao.net/t/index.html#NewsContent&id='+item.art_id;
                    },200)
                },10);



            },
        }
    }
</script>
